import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { Play, Pause, Trash, Pencil } from '@phosphor-icons/react'

import { getAssetLink } from '../../../../../../helpers/get-asset-link'

const VoicemailItem = ({ voicemail, onDelete, onEdit }) => {
  const audioRef = useRef(null)
  const [isPlaying, setIsPlaying] = useState(false)

  const playAudio = () => {
    if (audioRef.current) {
      audioRef.current.play()
    }
  }

  const stopAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause()
      audioRef.current.currentTime = 0
    }
  }

  return (
    <div className="voicemail-item">
      <span>{voicemail.name}</span>
      <div>
        {voicemail.type === 'text' ? (
          <React.Fragment>
            <button className="button" onClick={() => onEdit(voicemail)}>
              <Pencil />
            </button>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <audio
              ref={audioRef}
              src={getAssetLink({ path: 'recordings', file: voicemail.recording })}
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
              onEnded={() => setIsPlaying(false)}
            />
            <button className="button" onClick={isPlaying ? stopAudio : playAudio}>
              {isPlaying ? <Pause weight="fill" /> : <Play weight="fill" />}
            </button>
          </React.Fragment>
        )}
        <button className="button button-red" type="button" onClick={() => onDelete(voicemail)}>
          <Trash />
        </button>
      </div>
    </div>
  )
}

VoicemailItem.propTypes = {
  voicemail: PropTypes.object,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
}

export default VoicemailItem
